import React from 'react';
import { Link } from 'react-router-dom';
import businessAnalysis from '../images/business-analysis-icon.svg';
import productOwner from '../images/product-owner-icon.svg';
import scrumMaster from '../images/scrum-master-icon.svg';

const blogs = [
  {
    id: 1,
    title: "Agile Transformatie",
    subtitle: "Meer dan alleen ceremonies",
    date: "24 maart 2024",
    readTime: "5 min",
    category: "Agile",
    image: businessAnalysis,
    content: `Als ervaren Agile coach zie ik vaak dat organisaties vastlopen in hun Agile transformatie omdat ze te veel focussen op de ceremonies en te weinig op de mindset. In deze blog deel ik mijn ervaringen over hoe je een succesvolle Agile transformatie realiseert door de mens centraal te stellen.`
  },
  {
    id: 2,
    title: "Product Owner Excellence",
    subtitle: "Van goed naar excellent",
    date: "17 maart 2024",
    readTime: "4 min",
    category: "Product Management",
    image: productOwner,
    content: `Wat maakt een Product Owner echt succesvol? In mijn ervaring gaat het verder dan alleen backlog management en stakeholder communicatie. Het draait om het vermogen om strategisch te denken én pragmatisch te handelen.`
  },
  {
    id: 3,
    title: "Requirements & Pragmatisme",
    subtitle: "De juiste balans vinden",
    date: "10 maart 2024",
    readTime: "6 min",
    category: "Business Analysis",
    image: scrumMaster,
    content: `Requirements zijn essentieel, maar kunnen ook verlammend werken als ze te rigide worden toegepast. Als Business Analist heb ik geleerd dat de kunst ligt in het vinden van de juiste balans.`
  }
];

const Blogs = () => (
  <main>
    <section className="diensten" id="blogs">
      <h2 className="text-3xl font-bold text-[#2B4055] mb-12 text-center">Blog & Insights</h2>
      <div className="diensten-grid">
        {blogs.map((blog, index) => (
          <div key={index} className="dienst-card">
            <div className="dienst-header">
              <img src={blog.image} alt={blog.title} className="dienst-icon" />
            </div>
            <div className="dienst-content">
              <div className="text-sm text-gray-600 mb-2">
                {blog.date} • {blog.readTime} leestijd
              </div>
              <h3 className="text-xl font-bold text-[#2B4055] mb-2">{blog.title}</h3>
              <h4 className="text-lg text-[#EE3124] mb-4">{blog.subtitle}</h4>
              <p className="text-gray-700 mb-6">{blog.content}</p>
              <Link 
                to={`/blog/${blog.id}`} 
                className="btn-primary"
              >
                Meer lezen
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  </main>
);

export default Blogs;